import { FEEDBACK_URL } from '../constants/AppConstants';
import '../assets/css/FooterFeedbackBanner.scss';

const FooterFeedbackBanner = () => (
  <div className="feedback-banner">
    <div className="container hods-width-container feedback-banner--text-container">
      <h2 className="hods-heading-s">We welcome your feedback</h2>
      <p className="hods-body-s" data-testid="feedbackText">Help us improve this service by completing a <a className="govuk-link" href={FEEDBACK_URL} target="_blank" rel="noreferrer">short survey (opens in new tab)</a>.</p>
    </div>
  </div>
);

export default FooterFeedbackBanner;
